import { createReducer } from 'typesafe-actions';

import {
  IPasswordStrategyState,
  TPasswordStrategyAction,
  PasswordConfigActionTypes,
} from '@/store/types/password-config.types';

const initialState: IPasswordStrategyState = {
  passwordStrategy: {
    passwordChangeRedirectUrl: '',
    passwordPattern: {
      minLength: 12,
      requireLetters: true,
      requireCaseDiff: true,
      requireNumbers: true,
      requireSpecialCharacter: true,
    },
  },
  isLoading: false,
};

export const passwordStrategyReducer = createReducer<IPasswordStrategyState, TPasswordStrategyAction>(initialState)
  .handleType(PasswordConfigActionTypes.GET_PASSWORD_STRATEGY, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(PasswordConfigActionTypes.GET_PASSWORD_STRATEGY_SUCCESS, (state, action) => {
    return {
      ...state,
      passwordStrategy: action.passwordStrategy,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(PasswordConfigActionTypes.GET_PASSWORD_STRATEGY_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }))

  .handleType(PasswordConfigActionTypes.SET_PASSWORD_STRATEGY, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(PasswordConfigActionTypes.SET_PASSWORD_STRATEGY_SUCCESS, (state, action) => {
    return {
      ...state,
      passwordStrategy: action.passwordStrategy,
      isLoading: false,
      error: undefined,
    };
  })

  .handleType(PasswordConfigActionTypes.SET_PASSWORD_STRATEGY_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }));
